@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */
:host {
  display: block;
}

a , a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
 
}

.img-rounded-border {
  border:10px solid red;
  border-radius:10px;
}

#raw-html-style {
  padding:10px;
}

.card {
  border: none;
}


.carousel-indicators  {
  position: static;
}
/* .carousel-indicators button {
  background-color: black;
}
.carousel-indicators button .active {
  background-color: black;
} */
::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3; 
}

.modal-backdrop {
  display:none;
}

/* .carousel-item {
  transition: transform 2s ease, opacity .5s ease-out;
 } */


